/* unplugin-vue-components disabled */import script from "./ConfiguratorSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfiguratorSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ConfiguratorSidebar.vue?vue&type=style&index=0&id=32df1cb6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32df1cb6"]])

export default __exports__